import { Component } from '@angular/core';
@Component({
standalone: false,
  selector: 'app-express-payment-unavailable-dialog',
  styleUrls: ['./express-payment-unavailable-dialog.component.scss'],
  templateUrl: './express-payment-unavailable-dialog.component.html',
})
export class ExpressPaymentUnavailableDialogComponent {}
